import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import MaterialReactTable from 'material-react-table';
import { faEye } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import { MultiSelect } from "react-multi-select-component";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

const CropSurveyDetails = () => {
    const navigate = useNavigate();
    const [stateValue, setStateValue] = useState("");
    const [districtValue, setDistrictValue] = useState("");
    // const [iuLevelValue, setiuLevelValue] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropValue, setCropValue] = useState("");

    const [iuLevelData, setiuLevelData] = useState([]);
    const [formsData, setFormsData] = useState([]);
    const [statesData, setStatesData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    let [optionsState, setOptionsState] = useState([]);
    const [selected, setSelected] = useState([]);
    let globalFormData = [];

    useEffect(() => {
     
        fetchData();
        getCrop()
    }, []);

    const fetchData = async () => {
        const result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/trancropsurvey/getCropSurveyByUserCode`, {
            "userCode": localStorage.getItem("userCodeGlobal")
        });
        globalFormData = result.data.dataContent;
        setFormsData(result.data.dataContent);

    };

    function navigateTo(value) {
        navigate("/cropic/cropsurveyview", { state: { cropSurveyCode: value.row.original.cropSurveyCode } })
    }

    function getStates() {
        const fetchStates = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicstates`);
            setStatesData(result.data.dataContent);
        };
        fetchStates(); 
    }

    function handleState(value) {
        setStateValue(value);
        setDistrictData([])

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "stateCode": Number(value)
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Cropicdistrict`, requestOptions)
            .then(response => response.text())
            .then(result => setDistrictData(JSON.parse(result).dataContent))
            .catch(error => console.log('error', error));
    }

   

    function getCrop() {
        const fetchCrop = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/crop`);
            let localFormData = result.data.dataContent
            let myArray = [];
            localFormData.map((item, key) => {
                myArray.push({ label: item.cropName, value: item.cropCode })
            })
            setOptionsState(myArray)
        };
        fetchCrop();
    }

    function handleFilter() {
        if(startDate || endDate || stateValue || districtValue || selected.length > 0) {
            setFormsData(globalFormData);
            let filterArray;
            let formatStartDate = new Date(startDate.replaceAll("-", ","));
            let formatEndDate = new Date(endDate.replaceAll("-", ","));
    
            if(startDate || endDate) {
                filterArray = formsData.filter((x) => {       
                    let date = new Date(x.createModifyByIntUser.createdOnByUC.split("T")[0].replaceAll("-", ","));  
                    return (
                          formatStartDate <= date &&  date <= formatEndDate
                    )
                });
            }
          
            if (stateValue) {
                if (districtValue) {
                  
                    filterArray = formsData.filter((x) => {

                         return (x.stateCode == stateValue && x.districtCode == districtValue) })
                 
                } else {
                 
                    filterArray = formsData.filter((x) => { return (x.stateCode == stateValue) })
                  
                }          
            }
          
            if (selected.length > 0) {
                let cropNameArray = [];
               
                selected.map((item, key) => cropNameArray.push(item.label))
                   filterArray = formsData.filter(item => {
                    return cropNameArray.includes(item.cropName)
                })
              
            }
    
            setFormsData(filterArray)      
            // document.getElementById("findBtn").disabled = true;
            document.getElementById("clearBtn").disabled = false;


        } else {
            alert("Select Any Field to Filter")
        }
    
    }

    function handleClearFilter() {
        setStateValue("")
        setDistrictValue("")
        // setiuLevelValue("")
        setCropValue("")
        setSelected([])
        setStartDate("");
        setEndDate("")
        document.getElementById("startDate").value = "";
        document.getElementById("endDate").value = "";
        document.getElementById("findBtn").disabled = false;
        fetchData()
    }

    function formatDate(originalRow) {
    
        let valuess = (originalRow.createModifyByIntUser.createdOnByUC).split("T")
        var format = valuess[0].split("-")
        var formatTime = valuess[1].split(":")
        return format[2] + "-" + format[1] + "-" + format[0] + " "+ formatTime[0] + ":" + formatTime[1]
        
    }

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'seasonName',
                header: 'Season',
            },
            {
                accessorKey: 'cropName',
                header: 'Crop',
            },
          

            {
                accessorKey: 'userName',
                header: 'Surveyor Name',
            },
            {
                header: 'Survey Date',
                accessorFn: (originalRow) => formatDate(originalRow), //alternative to accessorKey, using accessorFn
                id: 'createModifyByIntUser.createdOnByUC',
            },
            {
                accessorKey: 'stateName',
                header: 'State Name',
            },
            {
                accessorKey: 'districtName',
                header: 'District Name',
            },
            {
                accessorKey: 'blockName',
                header: 'Block Name',
            },
            {
                accessorKey: 'villageName',
                header: 'Village Name',
            },
            {
                accessorKey: 'years',
                header: 'Year',
            },
            {
                accessorKey: 'iuName',
                header: 'IU Name',
            },
            {
                accessorKey: 'insuranceCompanyName',
                header: 'Insurance Company Name',
            },
            {
                accessorKey: 'adversityRemarks',
                header: 'Remarks',
            },
            {
                accessor: '',
                header: 'View Details',
                Cell: cell => <button className="btn" type="button" onClick={() => navigateTo(cell)}> <i><FontAwesomeIcon icon={faEye} /></i></button>
            },
        ],
        [],
    );

    // State and end date validation 

    // $('#startDate').datepicker({
    //     onSelect: function(dateText, inst){
    //         $('#endDate').datepicker('option', 'minDate', new Date(dateText));
    //     },
    // });
    
    // $('#endDate').datepicker({
    //     onSelect: function(dateText, inst){
    //         $('#startDate').datepicker('option', 'maxDate', new Date(dateText));
    //     }
    // });

    return (
        <>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Crop Survey Details</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">Crop Survey Details</li>
                        </ol>
                    </nav>

                </div>
                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <form className="row g-3">
                                        <div className="col-md-2">
                                            <label htmlFor="startdate" className="form-label">Start Date</label>
                                            <input type="date" className="form-control" id="startDate"  max={endDate} onChange={e => setStartDate(e.target.value)} />
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="enddate" className="form-label">End Date</label>
                                            <input type="date" className="form-control" id="endDate" min={startDate} onChange={e => setEndDate(e.target.value)} />
                                        </div>
                                         
                                        <div className="col-md-3">
                                            <label htmlFor="State" className="form-label">State</label>
                                            <select id="State" required className="form-select" onClick={getStates} onChange={(e) => handleState(e.target.value)} value={stateValue}>
                                                <option defaultValue>Choose...</option>
                                                {statesData.map((item, id) => {
                                                    return <option key={id} value={item.stateCode}> {item.stateName}</option>
                                                })}
                                            </select>
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="District" className="form-label">District</label>
                                            <select id="District" className="form-select" onChange={(e) => setDistrictValue(e.target.value)} value={districtValue}>
                                                <option defaultValue>Choose...</option>

                                                {districtData.map((item, id) => {
                                                    return <option key={id} value={item.districtCode}> {item.districtName}</option>
                                                })}
                                            </select>
                                        </div>
                                      
                                        {/* <div className="col-md-2">
                                            <label htmlFor="iulevel" className="form-label">IU Level</label>
                                            <select id="iulevel" className="form-select" onClick={getIULevel} onChange={e => setiuLevelValue(e.target.text)} value={iuLevelValue}>
                                                <option defaultValue>Choose...</option>
                                                 {iuLevelData  ? iuLevelData.map((item, id) => {
                                                    return <option key={id} value={item.iu_level}> {item.iu_name}</option>
                                                }) : ''}
                                            </select>
                                        </div>  */}
                                        <div className="col-md-2">
                                            <label htmlFor="inputcrop" className="form-label">Crop</label>

                                            <MultiSelect
                                                options={optionsState}
                                                value={selected}
                                                onChange={setSelected}
                                                labelledBy={"Select"}
                                                isCreatable={true}

                                            />
                                        </div>
                                        <div className="col-md-12 d-flex justify-content-md-center">

                                            <button type="button" className="btn btn-primary me-md-2" onClick={handleFilter} id="findBtn">Find</button>
                                            <button type="button" className="btn btn-primary me-md-2" onClick={handleClearFilter} id="clearBtn">Clear</button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                            <div className="col-12 dashboard">
                                <div className="card">

                                    <MaterialReactTable
                                        columns={columns}
                                        data={formsData}
                                        enableColumnOrdering
                                        enablePagination={true}

                                    />

                                </div>
                            </div>
                         
                        </div>


                    </div>
                </section>

            </main>
           
        </>
    )
}

export default CropSurveyDetails;